import {
  Field,
  makeStyles,
  SpinButton,
  Switch,
  tokens,
} from '@fluentui/react-components';
import { useT } from '@powerportalspro/react';
import { ManyToManyLookupEdit, Section, SectionColumn } from '@powerportalspro/react-fluent';
import { useState } from 'react';

// Reuses the Blazor demo's localization keys so both stacks share the
// JSON. Framework flattens to `components.<FullTypeName>.<key>`.
const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Grids.ManyToManyLookupEditor.ManyToManyLookupEditorPropertiesDemo';

const useStyles = makeStyles({
  // Toolbar mirrors the TextEdit properties sample: inline Switches +
  // labeled number inputs, wrapping at narrow widths.
  toolbar: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: tokens.spacingHorizontalL,
  },
  inlineField: {
    flexShrink: 0,
    gridTemplateColumns: 'auto auto',
    '& label': {
      whiteSpace: 'nowrap',
    },
  },
  numberInput: {
    width: '85px',
  },
});

export function ManyToManyLookupEditorPropertiesSample() {
  const styles = useStyles();
  const t = useT();
  const [readOnly, setReadOnly] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [min, setMin] = useState(1);
  const [max, setMax] = useState(2);

  return (
    <Section>
      <SectionColumn
        header={
          <div className={styles.toolbar}>
            <Switch
              label={t(`${STRINGS_BASE}.readonly`)}
              labelPosition="before"
              checked={readOnly}
              onChange={(_, d) => setReadOnly(d.checked)}
            />
            <Switch
              label={t(`${STRINGS_BASE}.disabled`)}
              labelPosition="before"
              checked={disabled}
              onChange={(_, d) => setDisabled(d.checked)}
            />
            <Field
              label={t(`${STRINGS_BASE}.min`)}
              orientation="horizontal"
              className={styles.inlineField}
            >
              <SpinButton
                className={styles.numberInput}
                min={0}
                value={min}
                onChange={(_, d) => {
                  const n = typeof d.value === 'number' ? d.value : Number(d.displayValue);
                  if (Number.isFinite(n)) setMin(n);
                }}
              />
            </Field>
            <Field
              label={t(`${STRINGS_BASE}.max`)}
              orientation="horizontal"
              className={styles.inlineField}
            >
              <SpinButton
                className={styles.numberInput}
                min={0}
                value={max}
                onChange={(_, d) => {
                  const n = typeof d.value === 'number' ? d.value : Number(d.displayValue);
                  if (Number.isFinite(n)) setMax(n);
                }}
              />
            </Field>
          </div>
        }
      >
        <ManyToManyLookupEdit
          relationshipName="ppp_Account_ppp_Region_ppp_Region"
          minimumNumberOfItems={min}
          maximumNumberOfItems={max}
          readOnly={readOnly}
          disabled={disabled}
          style={{ maxWidth: '350px' }}
        />
      </SectionColumn>
    </Section>
  );
}
